export const FEATURE_FLAG_VALUE_SHARE_MODEL_TAB =
	"transactionalBenchmarkValueShareModelTab"
